export default __webpack_public_path__ + "static/media/Vikram-Pandya.03468e72.jpg";